import React from 'react';
import { getIsPriv } from 'config/index';

const IS_PRIV = getIsPriv();

interface Props {
  hide?: boolean;
}

/**
 * 私有化判断是否显示
 * @description 默认私有化显示、公版不显示，声明 hide 则正好相反
 */
const WithPrivateCheck: React.FC<Props> = ({ children, hide = false }) => {
  if (hide) return <>{!IS_PRIV && children}</>;
  return <>{IS_PRIV && children}</>;
};

export default WithPrivateCheck;
